import NumberFormatOptions = Intl.NumberFormatOptions;
import DateTimeFormatOptions = Intl.DateTimeFormatOptions;

export abstract class BdExportAsFileData {

  public abstract getExport(): Promise<BdExportAsFileDataSheet | BdExportAsFileDataSheet[]>
}

export interface BdExportAsFileDataSheet {
  sheetName?: string;
  data: BdExportAsFileDataRow[];
  fields: string[];
}

export type BdExportAsFileDataRow = BdExportAsFileDataRowItem[];

export interface BdExportAsFileDataRowItem {
  value: number | string | boolean | Date | null;
  type: 'number' | 'string' | 'boolean' | 'Date';
  format?: string | NumberFormatOptions | DateTimeFormatOptions;
}
